import React from 'react';
import { Trans } from '@lingui/macro';
import { booleanValidator, makeRequired } from '../../../OUI/Inputs';

export const tAddYNPayPrecLabel = <Trans>Pour accord</Trans>;

export const tAddYnPayPrecValidator = makeRequired(booleanValidator);
